module.exports = __webpack_public_path__ + "static/img/sharePink.6515efad.png";